require('./facts-menu.component.scss');

class FactsMenuController {
  constructor(CurrentFilterService, RouterService, PermissionService) {
    this.CurrentFilterService = CurrentFilterService;
    this.router = RouterService;
    this.permission = PermissionService;
  }

  get filter() {
    return this.CurrentFilterService.filter;
  }
}

export const FactsMenuComponent = {
  template  : require('./facts-menu.component.html'),
  controller: FactsMenuController,
};



// WEBPACK FOOTER //
// ./src/facts/facts-menu.component.js